import React, {useState, useContext} from "react";
import { Switch, Route, Link } from "react-router-dom";
import styled, {css} from "styled-components";
import StoreSbColor from "./StoreSbColor";
import StoreSbSize from "./StoreSbSize";
import { Scrollbars } from 'react-custom-scrollbars';
import { ProductContext } from '../context'

import { SbSelect } from '../sb/SbSelect';

import { themes, sections } from '../defaults';
import { relative } from "path";







export default function Sb0top({type}) {



const valueFromContext = useContext(ProductContext);



const getActive = (val)=> {
    let ret;
    themes.forEach((oneTheme, ind) => {
      return ret = oneTheme['id'] === val.getTheme('id') ? ind : ret;
    })
    return ret;
}



  return (
    <div className="x00">
      <div className="x0_selector">
        <div className="x0_selector_inner">
          <div className="x0_groups">
            <div className="x0_li">
              <div className="x_sectionhover">
                <div className="x0_d0 x0_d0--site">
                  <div className="x0_d0_bg">
                    <div className="x_contentimage">
                      <div className="x_contentimage_tint">
                        <div className="x_temp_tint_1" />
                      </div>
                      <div className="x_contentimage_static">
                        <div className="x_temp_pic1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="x0_li_name">
                <div>my_awesome_game_1...<br />Unpublished Changes</div>
              </div>
            </div>
            <div className="x0_li">
              <div className="x_sectionhover">
                <div className="x0_d0 x0_d0--site">
                  <div className="x0_d0_bg">
                    <div className="x_contentimage">
                      <div className="x_contentimage_tint">
                        <div className="x_temp_tint_2" />
                      </div>
                      <div className="x_contentimage_static">
                        <div className="x_temp_pic1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="x0_li_name">
                <div>my_awesome_game_1...<br />Unpublished Changes</div>
              </div>
            </div>
            <div className="x0_li">
              <div className="x_sectionhover">
                <div className="x0_d0 x0_d0--site">
                  <div className="x0_d0_add">
                    <div>add_circle</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="x0_groups">
            <div className="x0_li">
              <div className="x_sectionhover">
                <div className="x0_d0 x0_d0--widget">
                  <div className="x0_d0_bg">
                    <div className="x_contentimage">
                      <div className="x_contentimage_tint">
                        <div className="x_temp_tint_1" />
                      </div>
                      <div className="x_contentimage_static">
                        <div className="x_temp_pic1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="x0_li_name">
                <div>my_awesome_game_1...<br />Unpublished Changes</div>
              </div>
            </div>
            <div className="x0_li">
              <div className="x_sectionhover">
                <div className="x0_d0 x0_d0--widget">
                  <div className="x0_d0_add">
                    <div>add_circle</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="x0_idle">
        <div className="x0_current">


          <div href="#store0" className="p_x_builder_logo w-inline-block w--current">
          <Link to="/choose">
            <div className="p_x_builder_logo_ic p_x_builder_logo_ic--sb" />
          </Link>
          <div style={{color: '#ccc', fontSize: 22, width: 20, textAlign: 'center'}}>

          </div>

            {type === 'store' && <span style={{display: 'flex'}}>
            <div className="p_x_builder_logo_txt">Store</div>
            <div className="p_x_builder_logo_txt p_x_builder_logo_txt--2">Builder</div>
            </span>}

            {type === 'account' && <span style={{display: 'flex'}}>
            <div className="p_x_builder_logo_txt">Gamer Account</div>
            <div className="p_x_builder_logo_txt p_x_builder_logo_txt--2"></div>
            </span>}

            {type === 'paystation' && <span style={{display: 'flex'}}>
            <div className="p_x_builder_logo_txt">Pay Station</div>
            <div className="p_x_builder_logo_txt p_x_builder_logo_txt--2">Builder</div>
            </span>}


            {type === 'uikit' && <span style={{display: 'flex'}}>
            <div className="p_x_builder_logo_txt">UI-kit</div>
            {/* <div className="p_x_builder_logo_txt p_x_builder_logo_txt--2">Builder</div> */}
            </span>}

          </div>

          {/* <a href="#ps0" className="p_x_builder_logo w-inline-block">
            <div className="p_x_builder_logo_ic p_x_builder_logo_ic--payst" />
            <div className="p_x_builder_logo_txt">Pay Station</div>
            <div className="p_x_builder_logo_txt p_x_builder_logo_txt--2">editor</div>
          </a>
          <a href="#login0" className="p_x_builder_logo w-inline-block w--current">
            <div className="p_x_builder_logo_ic p_x_builder_logo_ic--login" />
            <div className="p_x_builder_logo_txt">Login</div>
            <div className="p_x_builder_logo_txt p_x_builder_logo_txt--2">Editor</div>
          </a> */}
        </div>
        <div className="x0_center">
          <div className="x0_top_screens0">
            <div>
              <div className="p_x_sol_all">
                <div className="p_button p_button--appearance-flatten">
                  <div>desktop</div>
                </div>
                <div className="p_x_card_filter_div" />
                <div className="p_button p_button--appearance-flatten inactive">
                  <div>tablet</div>
                </div>
                <div className="p_x_card_filter_div" />
                <div className="p_button p_button--appearance-flatten inactive">
                  <div>mobile</div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="x0_right"
        // style={{flexGrow: 1}}
        >


          {/* <div style={{width: '220px'}}>
            {valueFromContext && <SbSelect
              placeholder="Select shop preset"
              menuHandler={(val)=>{valueFromContext.setStateFrom('sections', sections[val])}}
              options={[
                {
                  title: 'Simple',
                  value: 0,
                },
                {
                  title: 'Large catalog',
                  value: 1,
                },
                {
                  title: 'VC and Subscriptions',
                  value: 2,
                },

              ]}

            />}
            </div>&nbsp;&nbsp;&nbsp;
            <div style={{width: '220px'}}>


              {valueFromContext && <SbSelect
                active = {getActive(valueFromContext)}
                placeholder="Select theme"
                menuHandler={(val)=>{valueFromContext.setStateFrom('theme', themes[val])}}
                options={themes.map((oneTheme, ind)=>(
                {
                  title: ()=>{
                    return (
                     <div style={{
                       alignSelf: 'stretch',
                       justifySelf: 'stretch',
                       position: 'relative',
                       width: '100%',
                       borderRadius: '4px',
                       margin: '2px 0',
                       padding: '0 8px',
                       left: '-4px',
                       right: '-4px',
                       display: 'flex',
                       alignItems: 'center',
                       color: oneTheme['colorText'],
                       backgroundColor: oneTheme['colorBg'],
                     }}>

                     <div style={{color: oneTheme['colorAccent'],
                        borderRadius: 100,
                        backgroundColor: oneTheme['colorAccentText'],
                        width: 20,
                        height: 20,
                        marginRight: 8,
                      }}
                      className="xx_but_menu_icon xx_but_sett_icon--blue">
                        <div>play_circle_filled</div>
                      </div>

                      {oneTheme['name']}

                     </div>
                    )
                  },
                  value: ind,
                }
              ))}
            />}

        </div> */}






          <div className="xsb_saving_login">
            <div className="xsb_saved_icon">
              <div>check</div>
            </div>
            <div className="xsb_saving_label">
              <div>Saved</div>
            </div>
          </div>
          <div className="x0_close"
            onClick={()=>{
              valueFromContext.setStateFrom('sbShown', !valueFromContext['sbShown'])
            }}
          >
            <div>close</div>
          </div>
        </div>
      </div>


    </div>



  )
}
